import axios from "axios"

export default function getOrder({ id }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/orders/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}